export interface ForgotPassword {
    username: string;
    forgotPasswordGuid: string;
    appType: string;
}

export function defaultForgotPasswordValues(): ForgotPassword {
  return {
    username: '',
    forgotPasswordGuid: '123',
    appType:'bbApp'
  }
}

